import { useOptionalSession } from 'src/contexts/SessionContext';

import { PaymentOption } from './_types';
import { getPaymentOptionDetails } from './utils';

/**
 * Returns a formatter for payment option details that falls back to the live
 * platform currency from the session when a payment option does not specify
 * its own currency. Prefer this hook over calling getPaymentOptionDetails
 * directly so the platform currency fallback is always applied.
 */
export const usePaymentOptionDetails = () => {
  const { session } = useOptionalSession();

  return (paymentOption?: PaymentOption, includeName = true) =>
    getPaymentOptionDetails(paymentOption, includeName, session?.defaultCurrency);
};
